<template>
   <div v-if="myObdobia">
        <v-row v-for="obdobie,index in myObdobia" :key="index" style="margin:1px" >
            <v-col cols=12>
                <div >
                    <div>
                        <v-row style="margin:1px" @click="rozbalObdobie(index)">
                            {{obdobie.obdobie}}
                            <v-spacer />
                            <v-icon v-if="rozbalitObdobie != index" @mousedown="rozbalObdobie(index)">expand_more</v-icon>
                            <v-icon v-if="rozbalitObdobie == index" @mousedown="rozbalitObdobie = -1">chevron_left</v-icon>
                        </v-row>
                    </div>
                    <div v-if="rozbalitObdobie == index">                        
                        <v-row style="margin: 2px; background-color: #E8F5E9; text-align: center">
                            <v-col cols="12"><h3>Zaradené</h3></v-col>
                        </v-row>
                        <v-row style="margin: 2px;background-color: #E8F5E9;">
                            <v-col cols="1"> </v-col>
                            <v-col cols="1"><b>skr.</b></v-col>
                            <v-col cols="2"><b>názov</b></v-col>
                            <v-col cols="1"><b>sem.</b></v-col>
                            <v-col cols="1"><b>dot.</b></v-col>
                            <v-col cols="3"><b>prednášajúci</b></v-col>
                            <v-col cols="3"><b>cvičiaci</b></v-col>                            
                        </v-row>
                        <div v-for="predmet, index2 in myData" :key="index2" :class="index2 % 2 === 0 ? 'even-row' : 'odd-row'">
                            <v-row>
                                <v-col cols="1" style="text-align: center;"> <v-icon color="red" @click="deleteSubject(index2, obdobie.obdobie, predmet.predmet_id)">delete</v-icon> </v-col>
                                <v-col cols="1">{{ predmet.skratka }}</v-col>
                                <v-col cols="2">{{ predmet.nazov}}</v-col>
                                <v-col cols="1">{{ predmet.semester }}</v-col>
                                <v-col cols="1">{{ predmet.prednasky }}/{{ predmet.seminare }}</v-col>
                                <v-col cols="3"> 
                                    <v-chip v-for="teacher, index3 in predmet.prednasajuci" :key="index3" density="compact" size="small"> 
                                        {{teacher.priezvisko}}
                                    </v-chip>
                                    <v-card v-if="editPrednasajuci == index2">
                                        <v-icon class="btn-close" @click="editPrednasajuci = -1">close</v-icon>
                                        <v-card-text>
                                            <h4>Vybraní (click to delete):</h4>
                                            <v-chip v-for="teach, index31 in predmet.prednasajuci" :key="index31" density="compact" size="small"
                                            @click="deleteVyucujuci(teach,index2,'P')"> 
                                                {{teach.priezvisko}}
                                            </v-chip>
                                        </v-card-text>
                                        <v-card-text>
                                            <h4>Zoznam (click to add):</h4>
                                            <v-chip v-for="teach, index32 in myTeachers" :key="index32" density="compact" size="small"
                                            @click="addVyucujuci(teach,index2,'P')"> 
                                                {{teach.priezvisko}}
                                            </v-chip>
                                        </v-card-text>
                                    </v-card>                                   
                                    <v-icon size="x-small" v-if="predmet.prednasky>0" @click="editPrednasajuci = index2">edit</v-icon>
                                </v-col>

                                <v-col cols="3"> 
                                    <v-chip v-for="teacher, index3 in predmet.cviciaci" :key="index3" density="compact" size="small"> 
                                        {{teacher.priezvisko}}
                                    </v-chip>
                                    <v-card v-if="editCviciaci == index2">
                                        <v-icon class="btn-close" @click="editCviciaci = -1">close</v-icon>
                                        <v-card-text>
                                            <h4>Vybraní (click to delete):</h4>
                                            <v-chip v-for="teach, index31 in predmet.cviciaci" :key="index31" density="compact" size="small"
                                            @click="deleteVyucujuci(teach,index2,'C')"> 
                                                {{teach.priezvisko}}
                                            </v-chip>
                                        </v-card-text>
                                        <v-card-text>
                                            <h4>Zoznam (click to add):</h4>
                                            <v-chip v-for="teach, index32 in myTeachers" :key="index32" density="compact" size="small"
                                            @click="addVyucujuci(teach,index2,'C')"> 
                                                {{teach.priezvisko}}
                                            </v-chip>
                                        </v-card-text>
                                    </v-card>                                   
                                    <v-icon size="x-small" v-if="predmet.seminare>0" @click="editCviciaci = index2">edit</v-icon>
                                </v-col>                       

                            </v-row>
                        </div>

                        <v-row style="margin: 2px; background-color: antiquewhite; text-align: center">
                            <v-col cols="12"><h3>Nezaradené</h3></v-col>
                        </v-row>
                        <div style="background-color: antiquewhite;" v-for="predmet, index2 in allSubjects.predmety_bc" :key="index2">
                            <v-row v-if="selectedSubjectsID.indexOf(predmet.id) == -1">
                                <v-col cols="1" style="text-align: center;"> <v-icon color="green" @click="addSubject(index,predmet.id,predmet.skratka,predmet.nazov,predmet.semester, predmet.prednasky, predmet.seminare)">done</v-icon> </v-col>
                                <v-col cols="1">{{ predmet.skratka }} </v-col>
                                <v-col cols="2">{{ predmet.nazov}}</v-col>
                                <v-col cols="1">{{ predmet.semester }}</v-col>
                                <v-col cols="1">{{ predmet.prednasky }}/{{ predmet.seminare }}</v-col>
                            </v-row>
                        </div>
                        <v-row style="margin: 1px; background-color: white; text-align: center">
                            ..............................................................
                            </v-row>
                        <div style="background-color: antiquewhite;" v-for="predmet, index2 in allSubjects.predmety_mgr" :key="index2">
                            <v-row v-if="selectedSubjectsID.indexOf(predmet.id) == -1">
                                <v-col cols="1" style="text-align: center;"> <v-icon color="green" @click="addSubject(index,predmet.id,predmet.skratka,predmet.nazov,predmet.semester, predmet.prednasky, predmet.seminare)">done</v-icon> </v-col>
                                <v-col cols="1">{{ predmet.skratka }} </v-col>
                                <v-col cols="2">{{ predmet.nazov}}</v-col>
                                <v-col cols="1">{{ predmet.semester }}</v-col>
                                <v-col cols="1">{{ predmet.prednasky }}/{{ predmet.seminare }}</v-col>
                            </v-row>
                        </div>

                    </div>
                </div>
            </v-col>
        </v-row>   
       
    </div>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            myObdobia: null, 
            myTeachers: null,
            myData : null,
            rozbalitObdobie: -1,
            allSubjects: null,
            selectedSubjectsID:[],
            subject_finished: false,
            search2: null,  
            editPrednasajuci: -1,
            editCviciaci: -1          
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getSeassonsAndTeachers()
            this.getAllSubjects()
        },
        getSeassonsAndTeachers() {
            axios.get('/get-evaluation-seassons-and-teachers', this.$store.getters.getAxiosConfig)
            .then(res => {
                if (res.data.message == 'OK') {
                    this.myObdobia = res.data.seassons
                    this.myTeachers = res.data.teachers
                }else {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
       },
       getAllSubjects() {
        axios.get('/get-study-plan', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.allSubjects = res.data
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        rozbalObdobie(_index) {
            this.rozbalitObdobie = _index
            this.getSubjects(this.myObdobia[_index])
        },
        getSubjects(_obdobie) {
            this.subject_finished = false
            const _data = {
                obdobie: _obdobie.obdobie
            }
            axios.post('/get-evaluation-subjects',_data, this.$store.getters.getAxiosConfig)
            .then(res => {
                this.myData = res.data.predmety 
                this.selectedSubjectsID = []
                for(let i=0;i<this.myData.length; i++) {
                    this.selectedSubjectsID.push(this.myData[i].predmet_id)
                }
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                this.subject_finished = true
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
       },
       addSubject(_index, _id,_skratka,_nazov,_semester, _prednasky,_seminare) {
            const _data = {
                obdobie: this.myObdobia[_index].obdobie,
                predmet_id: _id,
                skratka: _skratka,
                nazov: _nazov,
                semester: _semester,
                prednasky: _prednasky,
                seminare: _seminare
            }
            axios.post('/add-evaluation-subject',_data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    if (res.data.message == 'OK') {
                        this.selectedSubjectsID.push(_id)
                            this.myData.push({
                                id: _id,
                                skratka: _skratka,
                                nazov: _nazov,
                                semester: _semester,
                                prednasky: _prednasky,
                                seminare: _seminare,
                                prednasajuci: [],
                                cviciaci: [],
                                predmet_id: _id
                            })
                    } else {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error.name+': '+error.message)
                })
        },
        deleteSubject(_index,_obdobie, _predmet_id) {
            const _data = {
                obdobie: _obdobie,
                predmet_id: _predmet_id
            }
            axios.post('/delete-evaluation-subject',_data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    if (res.data.message == 'OK') {
                        let ind = this.selectedSubjectsID.indexOf(_predmet_id);
                        if (ind !=-1) { this.selectedSubjectsID.splice(ind, 1) };
                        this.myData.splice(_index,1)
                    } else {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error.name+': '+error.message)
                })

        },
        addVyucujuci(_teach,_index, _teach_type) {
            // kontrola ci tam uz nie je
            if (_teach_type == "P") {
                for(let i=0; i<this.myData[_index].prednasajuci.length; i++) {
                    if (this.myData[_index].prednasajuci[i].id == _teach.id) {
                        return;
                    }
                }
            }
            if (_teach_type == "C") {
                for(let i=0; i<this.myData[_index].cviciaci.length; i++) {
                    if (this.myData[_index].cviciaci[i].id == _teach.id) {
                        return;
                    }
                }
            }
            const _data = {
                obdobie: this.myObdobia[this.rozbalitObdobie].obdobie,
                predmet_id: this.myData[_index].predmet_id,
                teacher_id: _teach.id,
                teach_type: _teach_type
            }
            axios.post('/add-evaluation-teacher',_data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    if (res.data.message == 'OK') {
                        if (_teach_type == "P") {
                            this.myData[_index].prednasajuci.push({
                                id: _teach.id,
                                meno: _teach.meno,
                                priezvisko: _teach.priezvisko
                            })
                        }
                        if (_teach_type == "C") {
                            this.myData[_index].cviciaci.push({
                                id: _teach.id,
                                meno: _teach.meno,
                                priezvisko: _teach.priezvisko
                            })
                        }
                    } else {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error.name+': '+error.message)
                })
        },
        deleteVyucujuci(_teach,_index,_teach_type) {
            const _data = {
                obdobie: this.myObdobia[this.rozbalitObdobie].obdobie,
                predmet_id: this.myData[_index].predmet_id,
                teacher_id: _teach.id,
                teach_type: _teach_type
            }
            axios.post('/delete-evaluation-teacher',_data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    if (res.data.message == 'OK') {
                        if (_teach_type == "P") {
                            for(let i=0; i<this.myData[_index].prednasajuci.length; i++) {
                                if (this.myData[_index].prednasajuci[i].id == _teach.id) {
                                    this.myData[_index].prednasajuci.splice(i,1)
                                    return
                                }
                            }
                        }
                        if (_teach_type == "C") {
                            for(let i=0; i<this.myData[_index].cviciaci.length; i++) {
                                if (this.myData[_index].cviciaci[i].id == _teach.id) {
                                    this.myData[_index].cviciaci.splice(i,1)
                                    return
                                }
                            }
                        }
                    } else {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error.name+': '+error.message)
                })            
        }
    }

}
</script>
<style>
    .even-row {
        background-color: #E8F5E9; /* Farba pre párne riadky */
    }

    .odd-row {
        background-color: #ffffff; /* Farba pre nepárne riadky */
    }
</style>